import { useParams } from "react-router-dom";

import { useQuery } from "@tanstack/react-query";

import { Plants } from "../../../api/plants";
import { QueryKey } from "../../../consts/query-keys";

export const useConstraintsData = (shouldFetchData: boolean) => {
  const { datasetId, id } = useParams();
  const { data: constraintsData, isPending } = useQuery({
    queryKey: [QueryKey.ConstraintsSection, datasetId, id],
    queryFn: () =>
      Plants.getConstraints({
        path: { datasetId: +datasetId! as number, plantId: +id! as number },
      }).then(response => {
        return response;
      }),
    throwOnError: true,
    enabled: shouldFetchData,
  });

  return { constraintsData, isPending };
};
